import React, { Dispatch, SetStateAction } from "react"

import { CheckIcon, ExclamationTriangleIcon } from "@heroicons/react/24/solid"

export type SetupChecklistProps = {
  cameraMessage: string
  micMessage: string
  browserMessage: string
  validBrowser: boolean
  setInstructionsOpen: Dispatch<SetStateAction<string>>
  setupComplete: boolean
}

const SetupChecklist: React.FC<SetupChecklistProps> = ({
  cameraMessage,
  micMessage,
  browserMessage,
  validBrowser,
  setInstructionsOpen,
  setupComplete,
}) => {
  return (
    <div className="mx-auto space-y-1 font-medium">
      <span className="text-lg font-semibold">Setup checklist</span>
      <div>
        <span>Browser: </span>
        {validBrowser ? (
          <span className="text-green-600">
            Compatible{" "}
            <CheckIcon className="ml-1 inline h-5 w-5 align-middle" />
          </span>
        ) : (
          <>
            <span className="text-red-500">
              {browserMessage}{" "}
              <ExclamationTriangleIcon className="mr-2 inline-block h-5 w-5 align-middle lg:mr-4" />
            </span>
            <button
              onClick={() => setInstructionsOpen("browser")}
              className="m-0 cursor-pointer border-none bg-transparent p-0 italic text-sky-600 shadow-none outline-none"
            >
              How do I fix this?
            </button>
          </>
        )}
      </div>
      <div>
        <span>Camera: </span>
        {!setupComplete ? (
          <span className="text-gray-500">Checking video...</span>
        ) : cameraMessage ? (
          <>
            <span className="text-red-500">
              {cameraMessage}{" "}
              <ExclamationTriangleIcon className="mr-2 inline-block h-5 w-5 align-middle lg:mr-4" />
            </span>
            {cameraMessage.includes("blocked") && (
              <button
                onClick={() => setInstructionsOpen("camera")}
                className="m-0 cursor-pointer border-none bg-transparent p-0 italic text-sky-600 shadow-none outline-none"
              >
                How do I fix this?
              </button>
            )}
          </>
        ) : (
          <span className="text-green-600">
            Ready to go! <CheckIcon className="inline h-5 w-5 align-middle" />
          </span>
        )}
      </div>
      <div>
        <span>Microphone: </span>
        {!setupComplete ? (
          <span className="text-gray-500">Checking audio...</span>
        ) : micMessage ? (
          <>
            <span className="text-red-500">
              {micMessage}{" "}
              <ExclamationTriangleIcon className="mr-2 inline-block h-5 w-5 align-middle lg:mr-4" />
            </span>
            {micMessage.includes("blocked") && (
              <button
                onClick={() => setInstructionsOpen("mic")}
                className="m-0 cursor-pointer border-none bg-transparent p-0 italic text-sky-600 shadow-none outline-none"
              >
                How do I fix this?
              </button>
            )}
          </>
        ) : (
          <span className="text-green-600">
            Ready to go! <CheckIcon className="inline h-5 w-5 align-middle" />
          </span>
        )}
      </div>
    </div>
  )
}

export default SetupChecklist
